<template>
  <section class="vh-100 login">
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-5 px-0 d-none d-sm-block triangle-left">
          <div class="login__logo">
            <!-- <h1>Ecoles</h1> -->
            <!-- <p>Platforme Education <br />Culture & Sport</p> -->
            <img 
              src="../../assets/icons/logo-ecole.svg" 
              alt="logo" 
            > 
          </div>
        </div>
        <div class="col-sm-7 g-0 text-black skew-triangle">
          <div class="login__connexion">
            <div class="px-5 ms-xl-4 login__connexion__logo">
              <h2 class="h1 fw-bold mb-0">{{ $t('common.schools') }}</h2>
            </div>

            <div
              class="d-flex align-items-center h-custom-2 px-5 ms-xl-4 mt-5 pt-5 pt-xl-0 mt-xl-n5"
            >
              <form style="width: 23rem">
                <h3 class="mb-3 pb-3" style="letter-spacing: 1px">{{ $t('login.definepassword') }}</h3>
                <div class="alert alert-success" role="alert" v-if="validationLogin">
                  <p>
                    {{ $t('info.password') }}
                    <strong>
                      <u>
                        <a href="http://dev.myschool.com/login"  @click="login()">{{ $t('login.clique') }}</a>
                      </u>
                    </strong>{{ $t('login.acceder') }}
                  </p>
                </div>

                <div class="form-outline input-wrapper mb-4">
                  <div class="input-icon-wrapper input-icon-wrapper--password">
                    <input
                      :type="
                                                passwordType
                                                    ? 'password'
                                                    : 'text'
                                            "
                      id="form2Example28"
                      class="form-control form-control-lg style-input1"
                      v-model="password"
                      :class="
                                                v$.password.$error
                                                    ? 'text-fields-error'
                                                    : ''
                                            "
                      autocomplete="off"
                      placeholder="Mot de passe"
                    />
                    <i
                      class="icon-Show-eye"
                      @click.prevent="setPasswordType"
                      :class="
                                                passwordType
                                                    ? 'password'
                                                    : 'text'
                                            "
                    ></i>
                  </div>
                  <span
                    class="invalid-feedback"
                    v-if="v$.password.$error"
                  >{{ v$.password.$errors[0].$message }}</span>
                </div>

                <div class="form-outline input-wrapper mb-4">
                  <div class="input-icon-wrapper input-icon-wrapper--password">
                    <input
                      :type="
                                                passwordType2
                                                    ? 'password'
                                                    : 'text'
                                            "
                      id="form2Example28"
                      class="form-control form-control-lg style-input1"
                      v-model="password_confirmation"
                      :class="
                                                v$.password_confirmation.$error
                                                    ? 'text-fields-error'
                                                    : ''
                                            "
                      autocomplete="off"
                      placeholder="Confirmation mot de passe"
                    />
                    <i
                      class="icon-Show-eye"
                      @click.prevent="setPasswordType2"
                      :class="
                                                passwordType2
                                                    ? 'password'
                                                    : 'text'
                                            "
                    ></i>
                  </div>
                  <span class="invalid-feedback" v-if="v$.password_confirmation.$error">
                    {{
                    v$.password_confirmation.$errors[0]
                    .$message
                    }}
                  </span>
                </div>

                <div class="pt-1 mb-4 button-login">
                  <button
                    @click.prevent="submitForm"
                    class="btn btn-outline-primary button"
                    :disabled="loading"
                  >
                    {{ $t('button.connect') }}
                    <i class="icon-Arrow"></i>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import useValidate from "@vuelidate/core";
import {
  required,
  minLength,
  sameAs,
  email,
  helpers
} from "@vuelidate/validators";
import AuthService from "../../services/auth.service";
export default {
  name: "confirmationPassword",
  components: {},
  data() {
    return {
      v$: useValidate(),
      loading: false,
      password_confirmation: "",
      password: "",
      token: null,
      email: null,
      submited: false,
      activatedUserEmail: null,
      validationLogin: false,
      passwordType: true,
      passwordType2: true
    };
  },
  validations() {
    return {
      password: {
        required: required,
        minLength: minLength(8)
      },
      password_confirmation: {
        required,
        samePassword: sameAs(this.password)
      }
    };
  },
  computed: {},
  created() {
    this.token = this.$route.query.token;
    this.email = this.$route.query.email;
 
  },
  //Ajout le test de token expired
  methods: {
    submitForm() {
      this.loading = true;
      this.v$.$validate(); // checks all inputs
      if (!this.v$.$error) {
        let data = {
          email: this.$route.query.email,
          password: this.password,
          password_confirmation: this.password_confirmation,
          token: this.token
        };
        this.loading = true;

        AuthService.resetPassword(data).then(response => {
          this.$store.dispatch("auth/login", data).then(
          (user) => {
            user.role?.map((rol)=>{
               if(rol.name === "admin_school" || rol.name === 'parent'){
                    this.$router.push("/");
               }else{
                  this.$router.push("/listecole");
               }
            })
            this.loading = false;
          },
          () => {
            this.Errormessage=true
            this.loading = false;
          }
        );
          this.validationLogin = true;
          this.loading = false;
        });
      } else {
        this.loading = false;
      }
    },
    setPasswordType() {
      this.passwordType = !this.passwordType;
    },
    setPasswordType2() {
      this.passwordType2 = !this.passwordType2;
    },
    login() {
    }
  },
  watch: {}
};
</script>
